import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";

import * as serviceWorker from "./serviceWorker";
import WithAxios from "WithAxios";

ReactDOM.render(
  // <Router basename="/smarthealth">
  <Router basename={process.env.REACT_APP_SUB_FOLDER_INDEX}>
    <WithAxios>
      <App />
    </WithAxios>
  </Router>,
  document.getElementById("root")
);

// If you want your app to work ogiffline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
